import { createBrowserRouter } from "react-router";
import websiteRouter from "./website/router";
import adminRouter from "./admin/router";
import adminAuthRouter from "./admin/authRouter";
import clientRoutes from "./client/route";
import clientAuthRoute from "./client/clientAuthRoute";

const router = createBrowserRouter([
  websiteRouter,
  adminRouter,
  adminAuthRouter,
  clientRoutes,
  clientAuthRoute,
]);

export default router;
